import Tooltip from '@components/common/presentational/tooltip/tooltip';

import QuestionMark from '@img/subscription/question_mark_white.svg';

import styles from './edit.tags.styles';

export function OutOfStockTag({tooltip}: {tooltip?: boolean}) {
    return (
        <div className={`tags ${styles}`}>
            <div className="tag">
                Out of Stock
            </div>
            {tooltip &&
                <Tooltip
                    width={300}
                    className="tooltip"
                    description={
                        `To avoid delays, please remove the out of stock item(s) from your upcoming order.`
                    }>
                    <img loading="lazy" style={{ margin: 0, marginLeft: 5 }} src={QuestionMark} alt="Question Mark" />
                </Tooltip>
            }
        </div>
    );
}